const ApiService = {
    query(resource, params) {
        return axios
            .get(resource, params)
            .catch((error) => {
                throw new Error(`[RWV] ApiService ${error}`);
            })
    },
    get(resource, slug = '') {
        return axios
            .get(`${resource}/${slug}`)
            .catch((error) => {
                throw new Error(`[RWV] ApiService ${error}`);
            })
    },
    getList(resource, slug = '', list = '') {
        return axios
            .get(`${resource}/${slug}/${list}`);
    },
    post(resource, params) {
        return axios.post(`${resource}`, params);
    },
    byCriteria(resource, params, slug = '', list = '') {
        return axios.get(`${resource}/${slug}/${params.limit}/${params.page}/${list}`)
            .catch((error) => {
                throw new Error(`[RWV] ApiService ${error}`);
            })
    },
    searchByCriteria(resource, params, slug = '', list = "") {
        return axios.post(`${resource}/${slug}/${list}`, params)
            .catch((error) => {
                throw new Error(`[RWV] ApiService ${error}`);
            })
    },
    update(resource, slug, params) {
        return axios.put(`${resource}/${slug}`, params);
    },
    put(resource, params) {
        return axios
            .put(`${resource}`, params);
    },
    delete(resource) {
        return axios
            .delete(resource);
    }
};
export default ApiService

export const OrganizationService = {
    query(type, params) {
        return ApiService
            .query(
                'organization',
                {params: params}
            )
    },
    get(slug) {
        return ApiService.get('organization', slug);
    },
    getList(organizationId) {
        return ApiService.getList('organization', organizationId, 'users');
    },
    getConnections(slug) {
        return ApiService.get('organization/' + slug + '/connection');
    },
    create(params) {
        return ApiService.post('organization', {name: params.name, plan_id: params.plan_id});
    },
    addUser(params) {
        return ApiService.post(`organization/${params.id}/users`, params);
    },
    update(slug, name, plan_id) {
        return ApiService.update('organization', slug, {name, plan_id});
    },
    destroy(slug) {
        return ApiService.delete(`organization/${slug}`);
    },
    destroyUserOrganization(params) {
        return ApiService.delete(`organization/${params.organizationId}/users/${params.userId}`);
    }
};

export const ConnectionService = {
    query(type, params) {
        return ApiService
            .query(
                'connections',
                {params: params}
            )
    },
    get(slug) {
        return ApiService.get('connection', slug);
    },
    create(connection) {
        return ApiService.post('connection', connection);
    },
    update(slug, connection) {
        return ApiService.update('connection', slug, connection);
    },
    destroy(slug) {
        return ApiService.delete(`connection/${slug}`);
    },
    getByCriteria(params) {
        return ApiService.byCriteria(params.resource, params, params.id, params.list);
    },
    post(resource, parameters) {
        return ApiService.post(resource, parameters);
    }
};

export const QueryService = {
    query(type, params) {
        return ApiService
            .query(
                'query',
                {params: params}
            )
    },
    execute(params) {
        return ApiService.post('query/execute', params);
    },
    executeQuery(payload) {
        return ApiService.post(`query/execute/${payload.queryId}`, payload)
    },
    get(slug) {
        return ApiService.get('query', slug);
    },
    getResults(slug) {
        return ApiService.post(`query/execute/${slug}`, slug);
    },
    getByCriteria(params) {
        return ApiService.byCriteria(params.resource, params, params.id, params.list);
    },
    create(params) {
        return ApiService.post('query', params);
    },
    update(slug, params) {
        return ApiService.update('query', slug, params);
    },
    destroy(slug) {
        return ApiService.delete(`query/${slug}`);
    },
    destroyHistory(slug) {
        return ApiService.delete(`history/${slug}`);
    },
    getVisualizations(slug) {
        return ApiService.getList('query', slug, 'visualizations');
    },
    getReports(slug) {
        return ApiService.getList('query', slug, 'reports');
    }
};

export const VisualizationService = {
    get(slug) {
        return ApiService.get('visualization', slug);
    },
    getStatus(slug) {
        return ApiService.get('visualization/status', slug);
    },
    create(params) {
        return ApiService.post('visualization', params);
    },
    update(slug, params) {
        return ApiService.update('visualization', slug, params);
    },
    getVisualizations(organization_id) {
        return ApiService.getList('organization', organization_id, 'visualization');
    },
    getByCriteria(params) {
        return ApiService.byCriteria(params.resource, params, params.id, params.list);
    },
    searchByCriteria(idOrganization, params) {
        return ApiService.searchByCriteria('organization', params, idOrganization, 'visualization');
    },
    post(params) {
        return ApiService.post('visualization/' + params, 'organization_id: ' + params);
    },
    destroy(slug) {
        return ApiService.delete(`visualization/${slug}`);
    },
    getReports(slug) {
        return ApiService.getList('visualization', slug, 'reports');
    },
};

export const PlanService = {
    getPlans() {
        return ApiService.get('plans');
    }
};

export const ReportService = {
    getReports(organization_id) {
        return ApiService.getList('organization', organization_id, 'report');
    },
    getReport(params) {
        return ApiService.post(`report/${params.report_id}`, params);
    },
    getByCriteria(params) {
        return ApiService.byCriteria(params.resource, params, params.id, params.list);
    },
    create(params) {
        return ApiService.post('report', params);
    },
    update(id, params) {
        return ApiService.update('report', id, params);
    },
    destroy(slug) {
        return ApiService.delete(`report/${slug}`);
    }
};

const apiAccountBasePath = 'users';
export const AccountService = {
    me() {
        return ApiService.get('me');
    },
    get(id) {
        return ApiService.get(apiAccountBasePath, id);
    },
    create(params) {
        return ApiService.post(apiAccountBasePath, params);
    },
    update(id, params) {
        return ApiService.update(apiAccountBasePath, id, params);
    },
    updateDefaultOrg(id, params) {
        return ApiService.update(`${apiAccountBasePath}/organization`, id, params);
    },
    updatePassword(id, params) {
        return ApiService.update(`${apiAccountBasePath}/password`, id, params);
    },
    destroy(id) {
        return ApiService.delete(apiAccountBasePath + id);
    },
    activateUser(params) {
        return ApiService.post(`${apiAccountBasePath}/${params.id}/activate`, params);
    },
    getUnactiveUser(payload) {
        return ApiService.get(`${apiAccountBasePath}/${payload.id}/token`, payload.token);
    }
};
